<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="backmatter-rw Acknowledgments-rw auto-rw page-open-left-rw" epub:type="backmatter acknowledgments" id="acknowledgements">
<h1 class="acknowledgements-title"><a id="page-ix"></a><span href="#/toc#toc-acknowledgements" title="Link target outside of Sample">Acknowledgments</span></h1>
<p class="noindent">Once again, the Katie Mac Street Team has kicked serious booty! I’d like to shower blessings on everyone who participated, and who helped move the dragons toward total global domination! A huge thank you to the following Street Teamers:</p>
<div class="top">
<p class="ul-list">Chantal Clem</p>
<p class="ul-list">Mary McCormick</p>
<p class="ul-list">Dawn Henry</p>
<p class="ul-list">Veronica Godinez-Woltman</p>
<p class="ul-list">Shawna Szabo</p>
<p class="ul-list">Rebecca Taylor</p>
<p class="ul-list">Stacey S. Lewis</p>
<p class="ul-list">Barbara Bass</p>
<p class="ul-list">Erin Havey</p>
<p class="ul-list">Dawn Addleman</p>
<p class="ul-list">Kayla Lindberg</p>
<p class="ul-list">Julie Atagi</p>
<p class="ul-list">Susanna Jolicoeur</p>
<p class="ul-list">Theresa McFarland</p>
<p class="ul-list">Dawn Addleman</p>
<p class="ul-list"><a id="page-x"></a>Mandy Johnson</p>
<p class="ul-list">Katie Fortenbacher</p>
<p class="ul-list">Misty Snell</p>
<p class="ul-list">Amy Hallmark</p>
<p class="ul-list">Kala Bartic</p>
<p class="ul-list">Leona Merrow</p>
<p class="ul-list">Stacia Ahlfeld</p>
<p class="ul-list">LaJean Rodewald</p>
<p class="ul-list">Lisa Partridge</p>
<p class="ul-list">Christine Brooks</p>
<p class="ul-list">Tracy Goll</p>
<p class="ul-list">Heather W. Mottel</p>
<p class="ul-list">Nicole Harris</p>
<p class="ul-list">Cheryl Ann Moore</p>
<p class="ul-list">Lynne Smith-Kinniburgh</p>
<p class="ul-list">Carrie Parker</p></div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?aaa48610